export default __webpack_public_path__ + "static/media/edit.42393ab5.svg";